<template>
  <div class="retry-container">
    <button
      class="btn btn-primary-stroked ripple ripple--stroked"
      @click="onClick()"
    >
      تلاش مجدد
    </button>
  </div>
</template>

<script>
export default {
  name: "app-retry",

  methods: {
    onClick() {
      this.$emit("onChange");
    },
  },
};
</script>
